'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _loadingAdminList = require('./loading-admin-list.component');

var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.loadingAdminList', []).component('loadingAdminList', _loadingAdminList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/loading-admin-list/loading-admin-list.module.js